import { render, staticRenderFns } from "./NextGame.vue?vue&type=template&id=001a563c&lang=pug&"
import script from "./NextGame.vue?vue&type=script&lang=js&"
export * from "./NextGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports